export default __webpack_public_path__ + "static/media/how-to-earn-rewards-with-coinmiles.fd3c076f.png";